// extracted by mini-css-extract-plugin
export default {"AlertContainer":"Alert_AlertContainer__G4+QR","Text":"Alert_Text__fJ8nl"};